/** @format */

import { Component, input, output } from '@angular/core';

import { NgClass } from '@angular/common';
import { ShippingOption } from '@plp/data-access/constants';

@Component({
	selector: 'plp-components-shipping-option-button',
	imports: [NgClass],
	templateUrl: './shipping-option-button.component.html',
	styleUrl: './shipping-option-button.component.scss'
})
export class ShippingOptionButtonComponent {
	readonly shippingOption = input<ShippingOption>();
	readonly selected = input(false);
	readonly disabled = input<boolean>();
	readonly count = input(0);
	readonly showCount = input(false);

	readonly selectedOption = output<void>();

	emitSelectedOption() {
		this.selectedOption.emit();
	}
}
